import { MinusOutlined, MoreOutlined, PlusOutlined } from '@ant-design/icons';
import { Button, Dropdown, Menu, Popconfirm, Popover, Progress, Select, Tag, Tooltip, } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import colorsDark from '../../../assets/colors/dark';
import IconCameraOn from '../../../assets/icons/camera_on.svg';
import IconSettings from '../../../assets/icons/settings.svg';
import LiveIconOn from '../../../assets/icons/live-streaming-on.svg';
import IconPin from '../../../assets/icons/push_pin.svg';
import * as SERVICE from '../../../constants/service.types';
import { getListDeviceGroupByParentDeviceGroupReturn, socketEmitEvent, } from '../../../redux/actions';
import { MODE_CAMERA, MODE_LIVE } from '../../../constants';
import { StateTag } from '../../../components/StateTag';

const progressColors = (percent) =>
  percent > 80
    ? colorsDark.$online
    : percent > 60
    ? colorsDark.$warning
    : colorsDark.$errors;

const MenuItemCamera = ({
  id,
  name,
  targetId,
  count = 0,
  selectedCamera,
  setSelectedCamera,
  setSelect,
  camera,
  owner,
  handleUpdateStream,
  handleRemoveDevice,
  handleUpdateCamera,
  idParentSelected,
  setIdParentSelected,
  setCheckLoading,
  total,
  onCreateGroup,
  setVisibleAdd,
  setDataArr,
  mode,
  setTimeRequest,
  // For change popup
  setIsVisibleHistoryEvent,
  setIsVisibleServices,
  setDataCameraHistoryEvent,
  setDataCameraService,
  pinCamera,
  pinnedCamera,
  unpinCamera,
  idLiveSelected,
  setIdLiveSelected,
  isExpanded,
  setIsExpanded,
  listDeviceGroupsData,
  refreshData,
  current,
}) => {
  const { namespace, listDeviceGroups, deviceGroup } = useSelector(
    (state) => state
  );
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [visibleDetail, setVisibleDetail] = useState(null);
  const [createCamera, setCreateCamera] = useState(false);
  const [prevParentDeviceGroups, setPrevParentDeviceGroups] = useState([]);
  const [prevListDevice, setPrevListDevice] = useState([]);
  const [visibleMoveCamera, setVisibleMoveCamera] = useState(false);
  const [showDropdownOption, setShowDropdownOption] = useState(false);
  const [toGroupSelected, setToGroupSelected] = useState(null);
  const handleClick = (idParent) => {
    setIsExpanded(!isExpanded);
    setIsOpen(!isOpen);
    setCheckLoading(!isOpen);
    if (idParent) {
      if (!isOpen) {
        console.log('click', camera);
        fetchListDeviceGroupByParentDeviceGroup(idParent);
        setIdParentSelected(idParent);
      }
    } else {
      if (mode === MODE_CAMERA) {
        setSelect(camera);
        setSelectedCamera(targetId);
      }
    }
  };
  const handleChangeLive = () => {
    if (mode === MODE_LIVE) {
      const dataTimeRequest = new Date().getTime();
      setTimeRequest(dataTimeRequest);
      dispatch(
        socketEmitEvent({
          appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
          requestId: dataTimeRequest,
          body: JSON.stringify({
            namespace,
            deviceGroupId: id,
            timeRequest: dataTimeRequest,
          }),
        })
      );
      setIdLiveSelected(id);
    }
  };
  const fetchListDeviceGroupByParentDeviceGroup = (parentDeviceGroupId) => {
    const dataTimeRequest = new Date().getTime();
    const data = {
      namespace,
      parentDeviceGroupId: parentDeviceGroupId,
    };
    let dataObjListDevice = {
      appServiceType: SERVICE.LIST_DEVICE_GROUP_BY_PARENT_DEVICE_GROUP,
      requestId: dataTimeRequest,
      body: JSON.stringify(data),
    };
    dispatch(getListDeviceGroupByParentDeviceGroupReturn());
    dispatch(socketEmitEvent(dataObjListDevice));

    dispatch(
      socketEmitEvent({
        appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
        requestId: dataTimeRequest,
        body: JSON.stringify({
          namespace,
          deviceGroupId: parentDeviceGroupId,
          timeRequest: dataTimeRequest,
        }),
      })
    );
  };

  useEffect(() => {
    if (
      listDeviceGroups?.length === 0 &&
      deviceGroup?.deviceGroup &&
      deviceGroup?.deviceGroup?.id === id
    ) {
      setPrevListDevice(deviceGroup.deviceGroup?.devices || []);
      if (prevParentDeviceGroups.length > 0) {
        const result = [];
        prevParentDeviceGroups.forEach((item) => {
          if (item.parentDeviceGroupId === id) {
            result.push(item);
          }
        });
        setPrevParentDeviceGroups(result);
      }
    } else if (
      listDeviceGroups?.length > 0 &&
      listDeviceGroups[0]?.parentDeviceGroupId === id &&
      listDeviceGroups[0]?.parentDeviceGroupId === idParentSelected &&
      deviceGroup?.deviceGroup &&
      deviceGroup?.deviceGroup?.id === id
    ) {
      if (!(prevParentDeviceGroups?.length > 0 && prevListDevice?.length > 0)) {
        setPrevParentDeviceGroups(listDeviceGroups || []);
        setPrevListDevice(deviceGroup.deviceGroup?.devices || []);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listDeviceGroups, deviceGroup]);
  useEffect(() => {
    return () => {
      setPrevListDevice([]);
      setPrevParentDeviceGroups([]);
    };
  }, []);

  const onChangeCreateGroup = () => {
    setVisibleAdd(true);
    setDataArr(null);
    setCreateCamera(false);
    setIdParentSelected(id);
  };

  const onPinCamera = () => {
    if (mode === MODE_LIVE) {
      pinCamera(camera);
    }
  };
  const handleChangePin = () => {
    if (!checkPin) {
      onPinCamera();
    }
  };
  const onChangeCreateCamera = () => {
    setCreateCamera(true);
    setVisibleAdd(true);
    setIdParentSelected(id);
    const dataTimeRequest = new Date().getTime();
    dispatch(
      socketEmitEvent({
        appServiceType: SERVICE.GET_DEVICE_GROUP_BY_ID,
        requestId: dataTimeRequest,
        body: JSON.stringify({
          namespace,
          deviceGroupId: camera?.id,
          timeRequest: dataTimeRequest,
        }),
      })
    );
  };

  useEffect(() => {
    if (camera?.id === deviceGroup?.deviceGroup?.id && createCamera) {
      setDataArr(deviceGroup?.deviceGroup);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camera.id, deviceGroup]);

  useEffect(() => {
    !showDropdownOption && setVisibleMoveCamera(false);
  }, [showDropdownOption]);
  const handleMoveToGroupOther = () => {
    let data = {
      namespace,
      deviceGroupId: camera.id,
      name: camera.name,
      type: camera.type,
      deviceInfos: JSON.parse(camera.deviceInfo),
      parentDeviceGroupId: toGroupSelected,
    };
    let dataObj = {
      appServiceType: SERVICE.UPDATE_DEVICE_GROUP,
      requestId: new Date().getTime(),
      body: JSON.stringify(data),
    };
    dispatch(socketEmitEvent(dataObj));
    refreshData(-1);
  };
  const menuModeCamera = (
    <Menu focusable>
      <Menu.Item
        key="1"
        onClick={() => {
          setShowDropdownOption(false);
          onChangeCreateGroup();
        }}
      >
        <span>
          <PlusOutlined />
          {t('Create new group')}
        </span>
      </Menu.Item>
      <Menu.Item
        key="2"
        onClick={() => {
          setShowDropdownOption(false);
          onChangeCreateCamera();
        }}
      >
        <span>
          <PlusOutlined />
          {t('Add camera to group')}
        </span>
      </Menu.Item>

      {camera.parentDeviceGroupId === -1 && (
        <Menu.Item
          key="3"
          onClick={() => {
            setVisibleMoveCamera(!visibleMoveCamera);
          }}
        >
          <span>
            <PlusOutlined />
            {t('Move to group other')}
          </span>
          {visibleMoveCamera && (
            <div
              name="speaker"
              onClick={(event) => event.stopPropagation()}
              style={{ marginTop: 10 }}
            >
              <Select
                style={{ width: '100%' }}
                showSearch
                placeholder={t('Select group camera')}
                optionFilterProp="children"
                filterOption={(input, option) => {
                  return (
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  );
                }}
                onChange={(value, option) => {
                  setToGroupSelected(value);
                }}
              >
                {(
                  listDeviceGroupsData?.filter((item) => item.id !== id) || []
                )?.map((d) => (
                  <Select.Option key={d.id} value={d.id}>
                    {d.name ? d.name : d.id}
                  </Select.Option>
                ))}
              </Select>
              {toGroupSelected && (
                <div style={{ marginTop: 10 }}>
                  <Button htmlType="submit" onClick={handleMoveToGroupOther}>
                    {t('Update')}
                  </Button>
                </div>
              )}
            </div>
          )}
        </Menu.Item>
      )}
    </Menu>
  );

  const checkPin = useMemo(() => {
    return pinnedCamera?.find((item) => item.serial === camera?.serial);
  }, [camera.serial, pinnedCamera]);

  const renderContentPopper = (
    <div className="popover-camera-setting">
      <div className="detail status">
        <div className="title">{t('State')}:</div>
        <div className="content">
          <StateTag state={camera?.state} />
        </div>
      </div>
      <div className="detail">
        <div className="title">{t('Address')}:</div>
        <div className="content">{camera?.note}</div>
      </div>
      <div className="detail">
        <div className="title">{t('Active at')}:</div>
        <div className="content">{camera?.createdAt}</div>
      </div>
      <div className="detail">
        <div className="title">{t('Permission')}:</div>
        <div className="content">
          {t(camera?.ownerId === owner ? 'Owner' : 'Viewer')}
        </div>
      </div>
      <div className="detail">
        <div className="title">{t('Strength')}:</div>
        <div className="content">
          <Progress
            percent={camera?.strength}
            steps={5}
            strokeColor={progressColors(camera?.strength)}
            format={(percent) => `${percent}%`}
          />
        </div>
      </div>
      <div className="detail">
        <div className="title">{t('Stream')}:</div>
        <div className="content" title={camera?.source}>
          {camera?.source && camera.source?.length > 15
            ? camera?.source.slice(0, 15) + '..'
            : camera?.source}
          {camera?.typeCamera == 'public_stream' ||
          camera?.typeCamera == 'streaming' ? (
            <a
              className="change_source hover-popup"
              style={{ color: '#0e9347' }}
              onClick={() => {
                setVisibleDetail(null);
                handleUpdateStream(camera);
              }}
            >
              {t('Change')}
            </a>
          ) : (
            ''
          )}
        </div>
      </div>
      <div className="detail">
        <div className="title">{t('History event')}:</div>
        <div
          className="title hover-popup"
          style={{ color: '#0e9347', cursor: 'pointer' }}
          onClick={() => {
            setDataCameraHistoryEvent(camera);
            setIsVisibleHistoryEvent(true);
            setVisibleDetail(null);
          }}
        >
          {t('Detail')}
        </div>
      </div>
      <div className="detail">
        <div className="title">{t('Services')}:</div>
        <div
          className="title hover-popup"
          style={{ color: '#0e9347', cursor: 'pointer' }}
          onClick={() => {
            setVisibleDetail(null);
            setDataCameraService(camera);
            setIsVisibleServices(true);
          }}
        >
          {t('Detail')}
        </div>
      </div>
      <div className="button-side">
        <Button
          className="delete"
          style={{
            color: colorsDark.$errors,
            borderColor: colorsDark.$errors,
          }}
          onClick={() => {
            setVisibleDetail(null);
            handleRemoveDevice(camera.name, camera.serial);
          }}
        >
          {t('Delete')}
        </Button>
        <Button
          onClick={() => {
            setVisibleDetail(null);
            handleUpdateCamera(camera);
          }}
        >
          {t('Edit')}
        </Button>
      </div>
    </div>
  );

  const renderCameraName = () => {
    const content = (
      <div
        style={{ paddingLeft: `${count * 6}px` }}
        className={`${targetId === selectedCamera ? 'selected-camera' : ''} ${
          id ? 'camera-parent' : 'camera-children'
        } ${current && camera.serial === current && 'camera-live--active'}`}
      >
        <div
          style={{
            display: 'flex',
            overflow: 'hidden',
          }}
          onClick={() => {
            if (setSelect) {
              setSelect(camera);
            }
          }}
        >
          {id && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
              onClick={() => handleClick(id)}
            >
              {isOpen ? (
                <MinusOutlined style={{ fontSize: 14, marginRight: 8 }} />
              ) : (
                <PlusOutlined style={{ fontSize: 14, marginRight: 8 }} />
              )}
              {/* <img
                className={`down-arrow__icon smooth-transition ${
                  isOpen ? 'open' : ''
                }`}
                style={{ width: '16px', height: '16px' }}
                src={isOpen ? DownArrowIcon : RightArrowIcon}
                alt="down-arrow"
              /> */}
            </div>
          )}
          <div className="camera-name__wrap">
            {!id && (
              <div>
                <img
                  className="down-arrow__icon"
                  style={{ width: '20px', height: '20px' }}
                  src={IconCameraOn}
                  alt="icon-camera-on"
                />
              </div>
            )}
            <span className="camera-name__title" onClick={handleChangeLive}>
              {name}
            </span>
          </div>
        </div>
        {id && (
          <div
            className="camera-parent__action"
            style={{ display: 'flex', alignItems: 'center' }}
            onClick={(e) => e.stopPropagation()}
          >
            {id && id === idLiveSelected && mode === MODE_LIVE && (
              <div className="icon-live-stream">
                <img
                  width={26}
                  height={26}
                  className="icon"
                  alt="live-stream-icon"
                  src={LiveIconOn}
                />
              </div>
            )}
            {mode === MODE_CAMERA && (
              <Dropdown
                trigger={['click']}
                overlay={menuModeCamera}
                onVisibleChange={(visible) => {
                  setShowDropdownOption(visible);
                }}
                visible={showDropdownOption}
              >
                <div>
                  <MoreOutlined style={{ fontSize: 20 }} />
                </div>
              </Dropdown>
            )}
          </div>
        )}
        {!id && mode === MODE_CAMERA && (
          <Popover
            trigger="click"
            visible={camera.serial === visibleDetail}
            onVisibleChange={(visible) =>
              visible ? setVisibleDetail(camera.serial) : setVisibleDetail(null)
            }
            key={camera.serial}
            placement="rightTop"
            content={renderContentPopper}
            title={<div className="title-item">{camera.name}</div>}
            onClick={(e) => e.stopPropagation()}
          >
            <div>
              <img
                className="down-arrow__icon"
                style={{ width: '20px', height: '20px' }}
                src={IconSettings}
                alt="icon-settings"
              />
            </div>
          </Popover>
        )}
        {!id && mode === MODE_LIVE && (
          <Popconfirm
            placement="rightTop"
            title={t('Are you sure to unpin this camera?')}
            okText={t('Yes')}
            onConfirm={() => unpinCamera(camera.serial)}
            cancelText={t('No')}
            disabled={!checkPin}
          >
            <div
              className="camera-pin__action"
              onClick={(e) => {
                e.stopPropagation();
                handleChangePin();
              }}
            >
              <img
                src={IconPin}
                alt="pin"
                className={`pin-icon ${checkPin ? 'pin-icon--active' : ''}`}
              />
            </div>
          </Popconfirm>
        )}
      </div>
    );
    return id ? (
      content
    ) : (
      <Tooltip placement="top" title={name}>
        {content}
      </Tooltip>
    );
  };
  return (
    <>
      <li className={`tree-camera__item ${id ? 'tree-camera__group' : ''}`}>
        {renderCameraName()}
        {isOpen &&
          [...prevParentDeviceGroups, ...prevListDevice]?.length > 0 && (
            <ul
              className={`camera-children__wrap ${
                count === 0 ? 'camera-children__root' : ''
              }`}
            >
              {[...prevParentDeviceGroups, ...prevListDevice].map((camera) => (
                <MenuItemCamera
                  key={camera.id ? camera.id : camera.targetId}
                  {...camera}
                  count={count + 1}
                  selectedCamera={selectedCamera}
                  setSelectedCamera={setSelectedCamera}
                  camera={camera}
                  setSelect={setSelect}
                  owner={owner}
                  handleUpdateStream={handleUpdateStream}
                  handleRemoveDevice={handleRemoveDevice}
                  handleUpdateCamera={handleUpdateCamera}
                  idParentSelected={idParentSelected}
                  setIdParentSelected={setIdParentSelected}
                  setCheckLoading={setCheckLoading}
                  total={total}
                  onCreateGroup={onCreateGroup}
                  setVisibleAdd={setVisibleAdd}
                  setDataArr={setDataArr}
                  //For visible popup
                  setIsVisibleHistoryEvent={setIsVisibleHistoryEvent}
                  setIsVisibleServices={setIsVisibleServices}
                  setDataCameraHistoryEvent={setDataCameraHistoryEvent}
                  setDataCameraService={setDataCameraService}
                  mode={mode}
                  setTimeRequest={setTimeRequest}
                  pinCamera={pinCamera}
                  pinnedCamera={pinnedCamera}
                  unpinCamera={unpinCamera}
                  idLiveSelected={idLiveSelected}
                  setIdLiveSelected={setIdLiveSelected}
                  isExpanded={isExpanded}
                  setIsExpanded={setIsExpanded}
                  listDeviceGroupsData={listDeviceGroupsData}
                  refreshData={refreshData}
                  current={current}
                />
              ))}
            </ul>
          )}
      </li>
    </>
  );
};
export default React.memo(MenuItemCamera);
